import { render, staticRenderFns } from "./EmployeeComplianceReminderDialog.vue?vue&type=template&id=864b2fbc&"
import script from "./EmployeeComplianceReminderDialog.vue?vue&type=script&lang=js&"
export * from "./EmployeeComplianceReminderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports